'use-strict';

module.exports = ['$scope', 'ngDroUAA', 'ngDroUtilsNotify',
    function ($scope, ngDroUAA, ngDroUtilsNotify) {
        
        
        $scope.kiosks = [];
//            KioskService.findByCompanyDistrict($scope.company.id).then(function (data) {
//                $scope.kiosks = data;
//            });

        
        ngDroUAA.Company.findAll().then(function (response) {
            $scope.companies = response.data;
        });
    }];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/components/company/companyDetail/tabs/company-kiosk.js
// module id = 419
// module chunks = 0